import { render, staticRenderFns } from "./UserSelectBox.vue?vue&type=template&id=5ef6f43a&scoped=true&"
import script from "./UserSelectBox.vue?vue&type=script&lang=js&"
export * from "./UserSelectBox.vue?vue&type=script&lang=js&"
import style0 from "./UserSelectBox.vue?vue&type=style&index=0&id=5ef6f43a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef6f43a",
  null
  
)

export default component.exports